import React from "react";
import { getNewsDate } from "../../../search/utils";

export function Date({ date }: { date: string }) {
	return <p className="post__date">{getNewsDate(date)}</p>;
}
